const req1 = require.context('.', true, /\.\/[^/]+\/[^/]+\/index\.js$/)
req1.keys().forEach((key) => {
  const componentName = key.replace(/^.+\/([^/]+\/[^/]+)\/index\.js/, '$1').replace('/', '')
  module.exports[componentName] = req1(key).default
})
